import { GET_ALL_COLLECTIONS_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/discovery/studio/rpc/CollectionsRpc.dfc.new';
import { GET_ALL_COLLECTIONS_QUERY as PUBLIC_GET_ALL_COLLECTIONS_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/discovery/studio/rpc/CollectionsRpc-external.dfc.new';
import { useAppContextQuery } from '../../hooks/useAppContextQuery';
// The DS lib CollectionCard resolves ecosystem.hubspot.com/marketplace URLs to
// in-app router paths (dropping the portal ID base) for both the CTA and the
// preview-item links. Build URLs in that shape so navigation works in the
// in-app and public storefronts without a custom link component.
const ECOSYSTEM_MARKETPLACE_BASE = 'https://ecosystem.hubspot.com/marketplace';
export function useDiscoveryCollections({
  skip
} = {}) {
  var _data$result$items, _data$result;
  const {
    data,
    loading,
    error
  } = useAppContextQuery({
    app: GET_ALL_COLLECTIONS_QUERY,
    public: PUBLIC_GET_ALL_COLLECTIONS_QUERY,
    options: {
      skip
    }
  });
  return {
    collections: (_data$result$items = data === null || data === void 0 || (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.items) !== null && _data$result$items !== void 0 ? _data$result$items : [],
    loading,
    error
  };
}
/** Maps DS preview items to the shape the DS lib CollectionCard expects,
 * linking each preview icon to its listing detail page. */
export function adaptDSPreviewItems(previewItems) {
  return previewItems.map(item => ({
    listingId: String(item.listingId),
    name: item.name,
    iconUrl: item.iconUrl || undefined,
    listingUrl: getListingUrl(item.slug)
  }));
}
export function getCollectionUrl(slug) {
  return `${ECOSYSTEM_MARKETPLACE_BASE}/featured/${slug}`;
}
export function getListingUrl(slug) {
  return `${ECOSYSTEM_MARKETPLACE_BASE}/listing/${slug}`;
}